import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [ModalProvider, useModalContext] = buildGlobalReferenceContext("ModalRoot");

export { ModalProvider, useModalContext };
//# sourceMappingURL=context.mjs.map
